<button class='btn btn-secondary py-2 px-3'
        type='button'
        placement='top'
        ngbTooltip="{{ 'CSV import' | translate }}"
        [attr.aria-label]="'CSV import' | translate"
        (click)='importCsv()'>
    <mon-icon [icon]="['ACTIONS', 'IMPORT']" [size]="'lg'"></mon-icon>
</button>
